import { render } from "./OktaSSO.vue?vue&type=template&id=0bbfbe77&scoped=true"
import script from "./OktaSSO.vue?vue&type=script&lang=js"
export * from "./OktaSSO.vue?vue&type=script&lang=js"

import "./OktaSSO.vue?vue&type=style&index=0&id=0bbfbe77&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bbfbe77"]])

export default __exports__